<template>
  <div>
    <modal-semanas :listSemanas="listSemanas"> </modal-semanas>
    <modal-recibo
      :partido="partidoSeleccionado"
      :listMultas="listMultas"
      :listDetalle="listDetalle"
      :listFijos="listValoreFijos"
      :hasRecibo="hasRecibo"
      :isReciboPagado="isReciboPagada"
      :bloquearElRecibo="bloquearElRecibo"
      :loadingRecibo="showLoadingRecibo"
      :dataReciboCabecera="dataReciboCabecera"
      @changeTab="changeTab($event)"
      @reciboGenerado="
        reciboGenerado()
        recargarMultasAlInsertar($event)
      "
      @reciboEliminado="
        reciboEliminado()
        recargarMultasAlEliminar($event)
      "
      @pagadoCorrectamente="
        reciboGenerado()
        recargarMultasAlInsertar($event)
        pagadoCorrectamente($event)
      "
    ></modal-recibo>
    <b-tabs pills>
      <b-tab title="Programación" active>
        <b-card no-body>
          <b-row class="m-1">
            <b-col md="5">
              <b-form-datepicker
                :date-disabled-fn="dateDisabled"
                placeholder="Seleccione la fecha"
                @input="getPartidosSemana"
                v-model="fechaPartido"
              />
            </b-col>
            <b-col md="4">
              <v-select
                placeholder="Seleccione Cancha"
                :options="listCanchas"
                :clearable="false"
                style="width: 100%"
                @input="getPartidosSemana"
                v-model="canchaSeleccionada"
              />
            </b-col>
            <b-col md="3">
              <b-button
                v-b-tooltip.hover.v-primary
                title="Detalle semanal"
                variant="flat-primary"
                class="btn-icon"
                size="sm"
                @click="showModalSemanas"
              >
                <feather-icon size="14" icon="DollarSignIcon" />
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              md="2"
              class="ml-1"
              style="margin-top:-13px;margin-bottom:5px"
            >
              <b-button
                v-if="totalPartidos !== 0"
                v-b-tooltip.hover.v-primary
                title="Imprimir Recibos"
                variant="flat-primary"
                size="sm"
                @click="printRecibos"
              >
                <feather-icon size="18" icon="PrinterIcon" />
              </b-button>
            </b-col>
            <b-col md="8" class="ml-1" style="margin-top:-7px;margin-bottom:5px"
              ><b-badge variant="warning">
                Los valores mostrados no incluyen los valores fijos ya que estos
                no ingresan a arcas de la Liga
              </b-badge></b-col
            >
          </b-row>

          <b-overlay :show="showLoadingPartidos" rounded="sm">
            <b-row v-if="partidos != null" class="m-0">
              <b-col md="2" v-if="partidos[0].partidos.length != 0">
                <b-row class="etiquetas"
                  ><b>Lunes {{ auxiliarDias[0] }}</b></b-row
                >
                <item-partido-cuota
                  v-for="item in partidos[0].partidos"
                  :key="item.id"
                  :partido="item"
                  @clickPartido="getMultaEquipoFirst($event)"
                ></item-partido-cuota>
              </b-col>
              <b-col md="2" v-if="partidos[1].partidos.length != 0">
                <b-row class="etiquetas"
                  ><b>Martes {{ auxiliarDias[1] }}</b></b-row
                >
                <item-partido-cuota
                  v-for="item in partidos[1].partidos"
                  :key="item.id"
                  :partido="item"
                  @clickPartido="getMultaEquipoFirst($event)"
                ></item-partido-cuota>
              </b-col>
              <b-col md="2" v-if="partidos[2].partidos.length != 0">
                <b-row class="etiquetas"
                  ><b>Miércoles {{ auxiliarDias[2] }}</b></b-row
                >
                <item-partido-cuota
                  v-for="item in partidos[2].partidos"
                  :key="item.id"
                  :partido="item"
                  @clickPartido="getMultaEquipoFirst($event)"
                ></item-partido-cuota>
              </b-col>
              <b-col md="2" v-if="partidos[3].partidos.length != 0">
                <b-row class="etiquetas"
                  ><b>Jueves {{ auxiliarDias[3] }}</b></b-row
                >
                <item-partido-cuota
                  v-for="item in partidos[3].partidos"
                  :key="item.id"
                  :partido="item"
                  @clickPartido="getMultaEquipoFirst($event)"
                ></item-partido-cuota>
              </b-col>
              <b-col md="2" v-if="partidos[4].partidos.length != 0">
                <b-row class="etiquetas"
                  ><b>Viernes {{ auxiliarDias[4] }}</b></b-row
                >
                <item-partido-cuota
                  v-for="item in partidos[4].partidos"
                  :key="item.id"
                  :partido="item"
                  @clickPartido="getMultaEquipoFirst($event)"
                ></item-partido-cuota>
              </b-col>
              <b-col md="2" v-if="partidos[5].partidos.length != 0">
                <b-row class="etiquetas"
                  ><b>Sábado {{ auxiliarDias[5] }}</b></b-row
                >
                <item-partido-cuota
                  v-for="item in partidos[5].partidos"
                  :key="item.id"
                  :partido="item"
                  @clickPartido="getMultaEquipoFirst($event)"
                ></item-partido-cuota>
              </b-col>
              <b-col md="2" v-if="partidos[6].partidos.length != 0">
                <b-row class="etiquetas"
                  ><b>Domingo {{ auxiliarDias[6] }}</b></b-row
                >
                <item-partido-cuota
                  v-for="item in partidos[6].partidos"
                  :key="item.id"
                  :partido="item"
                  @clickPartido="getMultaEquipoFirst($event)"
                ></item-partido-cuota>
              </b-col>
            </b-row>
          </b-overlay>
        </b-card>
      </b-tab>
      <b-tab title="General">
        <institucion
          :listInstituciones="listInstituciones"
          :showLoadingIns="showLoadingIns"
          :listCampeonatos="listCampeonatos"
          :seleccionado="campeonatoSeleccionado"
          :limpiarDerecha="limpiarDerecha"
          @limpiaDerecha="limpiandoDerecha($event)"
          @recargaInstitucions="getInstituciones(campeonatoSeleccionado.value)"
          @change="setearVar($event)"
        ></institucion>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import {
  BTabs,
  BTab,
  BCard,
  BFormDatepicker,
  BRow,
  BCol,
  BOverlay,
  BButton,
  VBTooltip,
  BBadge,
  //   cxxx
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
// import store from '@/store'
import {
  onMounted,
  ref,
  computed,
  watch,
  // onActivated,
} from '@vue/composition-api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import apiCall from '../../utils/apiCall'
import {
  URL,
  //   USER,
  //   ROLES,
  // xxx,
} from '../../utils/variables'
import ItemPartidoCuota from './ItemPartidoCuota.vue'
import ModalRecibo from './ModalReciboPogramacion.vue'
import ModalSemanas from './ModalSemanas.vue'
import Institucion from './Instituciones.vue'

const moment = require('moment-timezone')

export default {
  components: {
    BTabs,
    BTab,
    BCard,
    BFormDatepicker,
    vSelect,
    BRow,
    BCol,
    ItemPartidoCuota,
    ModalRecibo,
    ModalSemanas,
    Institucion,
    BOverlay,
    BButton,
    BBadge,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  setup() {
    const fechaPartido = ref('')
    const { postApi, getApi } = apiCall()
    const partidos = ref(null)
    const listCanchas = ref([])
    const listSemanas = ref([])
    const listCampeonatos = ref([])
    const canchaSeleccionada = ref(null)
    const auxiliarDias = ref([])
    const listMultas = ref([])
    const listValoreFijos = ref([])
    const listDetalle = ref([])
    const partidoSeleccionado = ref({})
    const bloquearElRecibo = ref('n')
    const showLoadingIns = ref(false)
    const showLoadingPartidos = ref(false)
    const showLoadingRecibo = ref(false)
    const listInstituciones = ref([])
    const hasRecibo = ref(false)
    const isReciboPagada = ref(false)
    const limpiarDerecha = ref(false)
    const fechas = ref([])
    const totalPartidos = ref(0)
    const dataReciboCabecera = ref({ fecha: '' })
    const campeonatoSeleccionado = ref({
      label: 'Seleccione campeonato',
      value: null,
    })

    async function getSemanasValores(idTorneo) {
      listSemanas.value = []
      const path = `ApiMultas/getWeeks/${idTorneo}`
      const data = await getApi(URL, path)
      // console.log(data)
      listSemanas.value = data
    }
    function reciboGenerado() {
      // hasRecibo.value = true
      // isReciboPagada.value = false
      getSemanasValores(
        // eslint-disable-next-line
        store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
        // eslint-disable-next-line
      )
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'GUARDADO con éxito',
            icon: 'AlertCircleIcon',
            variant: 'success',
            solid: true,
          },
        },
        {
          position: 'top-center',
          // eslint-disable-next-line
        },
      )
    }

    function reciboEliminado() {
      hasRecibo.value = false
      listDetalle.value = []
      getSemanasValores(
        // eslint-disable-next-line
        store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
        // eslint-disable-next-line
      )
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'ELIMINADO con éxito',
            icon: 'AlertCircleIcon',
            variant: 'success',
            solid: true,
          },
        },
        {
          position: 'top-center',
          // eslint-disable-next-line
        },
      )
    }
    async function printRecibos() {
      // console.log(partidos.value)
      window.open(
        `${URL}ApiMultas/printRecibos/${fechas.value[0]}/${fechas.value[6]}/${
          canchaSeleccionada.value.value
        }?v=${Math.random() * 100}`,
        // eslint-disable-next-line
        '_blank',
      )
    }
    function limpiandoDerecha(event) {
      // console.log(event)
      limpiarDerecha.value = event
    }
    function toArrayCanchas(array) {
      const listReturn = []
      array.forEach(element => {
        const obj = {
          label: `${element.nombre}`,
          value: element.id_cancha,
        }
        listReturn.push(obj)
      })
      return listReturn
    }
    async function getCanchas(idTorneo) {
      listCanchas.value = []
      const path = `ApiFixture/getCanchas/${idTorneo}`
      const data = await getApi(URL, path)
      listCanchas.value = toArrayCanchas(data.data)
    }

    function defineBloquear(tipo) {
      if (tipo === 'local') {
        bloquearElRecibo.value = partidoSeleccionado.value.bloquear_local
      } else {
        bloquearElRecibo.value = partidoSeleccionado.value.bloquear_visita
      }
    }
    async function getMultaEquipo(item, id, idRecibo, tipo) {
      partidoSeleccionado.value = item
      // console.log(partidoSeleccionado.value)
      listMultas.value = []
      listDetalle.value = []
      listValoreFijos.value = []
      hasRecibo.value = false
      showLoadingRecibo.value = true
      // console.log('aqui')
      const path = `ApiMultas/getMultasCompleto/${id}/${idRecibo}/${partidoSeleccionado.value.id_categoria}`
      const data = await getApi(URL, path)
      // console.log(data)
      showLoadingRecibo.value = false
      listMultas.value = data.data
      listDetalle.value = data.detalle_recibo
      hasRecibo.value = data.hasRecibo
      listValoreFijos.value = data.valoresFijos
      isReciboPagada.value = data.isReciboPagado
      dataReciboCabecera.value = data.recibo
      // store.commit('someVariables/UPDATE_SHOW_RECIBO', true)
      defineBloquear(tipo)
      // showLoadingPartidos.value = false
      // console.log(partidoSeleccionado.value)
    }
    function recargarMultasAlEliminar(data) {
      // console.log(data.tipo)
      // console.log(data.info)
      if (data.tipo === 'local') {
        getMultaEquipo(
          data.partido,
          data.info.id_equipo,
          // eslint-disable-next-line
          null,
          // eslint-disable-next-line
          'local',
        )
      } else {
        getMultaEquipo(
          data.partido,
          data.info.id_equipo,
          // eslint-disable-next-line
          null,
          // eslint-disable-next-line
          'visita',
        )
      }
    }
    function recargarMultasAlInsertar(data) {
      // console.log(data)
      // console.log(data.tipo)
      // console.log(data.info)
      if (data.tipo === 'local') {
        getMultaEquipo(
          data.partido,
          data.info.id_equipo,
          // eslint-disable-next-line
          data.info.id_recibo,
          // eslint-disable-next-line
          'local',
        )
      } else {
        getMultaEquipo(
          data.partido,
          data.info.id_equipo,
          // eslint-disable-next-line
          data.info.id_recibo,
          // eslint-disable-next-line
          'visita',
        )
      }
    }
    function pagadoCorrectamente(item) {
      // console.log(partidoSeleccionado)
      // console.log(item)
      if (item.tipo === 'local') {
        if (item.accion) {
          partidoSeleccionado.value.bloquear_local = 's'
        } else {
          partidoSeleccionado.value.bloquear_local = 'n'
        }
      } else if (item.tipo === 'visita') {
        if (item.accion) {
          partidoSeleccionado.value.bloquear_visita = 's'
        } else {
          partidoSeleccionado.value.bloquear_visita = 'n'
        }
      }
      // console.log(tipo)
      // defineBloquear(tipo)
      if (item.accion) {
        isReciboPagada.value = true
        bloquearElRecibo.value = 's'
      } else {
        isReciboPagada.value = false
        bloquearElRecibo.value = 'n'
      }

      getSemanasValores(
        // eslint-disable-next-line
        store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
        // eslint-disable-next-line
      )
    }
    // UPDATE `dividir_multa` SET bloquear='n', pagada='n';
    // UPDATE `multas` SET bloquear='n', pagada='n'
    // TRUNCATE detalle_recibo;
    // TRUNCATE recibo;
    function getMultaEquipoFirst(item) {
      getMultaEquipo(item, item.id_local, item.id_recibo_local, 'local')
      store.commit('someVariables/UPDATE_SHOW_RECIBO', true)
    }
    function showModalSemanas() {
      store.commit('someVariables/UPDATE_SHOW_SEMANA_TESORERIA', true)
    }

    function changeTab(item) {
      // console.log(item)
      if (item.tipo === 'local') {
        getMultaEquipo(
          item.partido,
          item.partido.id_local,
          // eslint-disable-next-line
          item.partido.id_recibo_local,
          // eslint-disable-next-line
          'local',
        )
      } else {
        getMultaEquipo(
          item.partido,
          item.partido.id_visita,
          // eslint-disable-next-line
          item.partido.id_recibo_visita,
          // eslint-disable-next-line
          'visita',
        )
      }
    }
    const cambioTorneo = computed(
      // eslint-disable-next-line
      () => store.getters['someVariables/getTorneoSeleccionado'],
    )
    function transformCampeonatos(array, salida) {
      array.forEach(element => {
        const obj = {
          label: `${element.anio_inic} - ${element.anio_fin}`,
          value: element.id_campeonato,
          id_torneo: element.id_torneo,
          activo: element.activo,
        }
        salida.value.push(obj)
      })
    }
    watch(cambioTorneo, data => {
      fechaPartido.value = ''
      partidos.value = null
      canchaSeleccionada.value = null
      listCampeonatos.value = []
      campeonatoSeleccionado.value = null
      listInstituciones.value = []
      limpiarDerecha.value = true
      getCanchas(data.id_torneo)
      getSemanasValores(data.id_torneo)
      transformCampeonatos(
        store.getters['someVariables/getTorneoSeleccionado'].campeonatos,
        // eslint-disable-next-line
        listCampeonatos,
      )
    })

    function dateDisabled(ymd, date) {
      const weekday = date.getDay()
      return (
        weekday === 0 ||
        weekday === 2 ||
        weekday === 3 ||
        weekday === 4 ||
        weekday === 5 ||
        weekday === 6
      )
    }
    function getArrayWeek(weekStart) {
      const arrayDias = []
      auxiliarDias.value = []
      for (let i = 0; i <= 6; i += 1) {
        const day = moment(weekStart)
          .add(i, 'days')
          // eslint-disable-next-line
          .format('YYYY-MM-DD')
        arrayDias.push(day)
        auxiliarDias.value.push(day.substring(8, 10))
        // console.log(`dias ${day}`)
      }
      return arrayDias
    }
    async function getPartidosSemana() {
      // console.log(fechaPartido.value)
      fechas.value = []
      totalPartidos.value = 0
      const currentDate = moment(fechaPartido.value)
      const weekStart = currentDate.clone().startOf('isoWeek')
      const arrayDias = getArrayWeek(weekStart)
      fechas.value = arrayDias

      showLoadingPartidos.value = true
      if (canchaSeleccionada.value !== null) {
        const path = `ApiMultas/getPartidosFechaCancha/${canchaSeleccionada.value.value}`
        const data = {
          dias: arrayDias,
        }
        const response = await postApi(URL, path, data)
        partidos.value = response.data
        totalPartidos.value = response.cont
      }
      showLoadingPartidos.value = false
      // console.log(partidos.value)
    }
    async function getInstituciones(idCampeonato) {
      // store.commit(
      //   'someVariables/UPDATE_UBICACION_ACTUAL',
      //   // eslint-disable-next-line
      //   UBICACIONES.INSTITUCIONES
      // )
      showLoadingIns.value = true
      listInstituciones.value = []
      limpiarDerecha.value = true
      const path = `ApiMultas/getInstitucionesMultas/${cambioTorneo.value.id_torneo}/${idCampeonato}`
      const data = await getApi(URL, path)
      listInstituciones.value = data
      showLoadingIns.value = false
    }
    function setearVar(item) {
      // console.log(item)
      campeonatoSeleccionado.value = item
      getInstituciones(item.value)
    }
    onMounted(() => {
      // eslint-disable-next-line
      getCanchas(
        // eslint-disable-next-line
        store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
        // eslint-disable-next-line
      )
      // eslint-disable-next-line
      getSemanasValores(
        // eslint-disable-next-line
        store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
        // eslint-disable-next-line
      )
      transformCampeonatos(
        store.getters['someVariables/getTorneoSeleccionado'].campeonatos,
        // eslint-disable-next-line
        listCampeonatos,
      )
      const campActivo = listCampeonatos.value.find(
        // eslint-disable-next-line
        element => element.activo === 's',
      )
      campeonatoSeleccionado.value = campActivo
      getInstituciones(campeonatoSeleccionado.value.value)
    })
    return {
      getPartidosSemana,
      fechaPartido,
      dateDisabled,
      partidos,
      listCanchas,
      canchaSeleccionada,
      auxiliarDias,
      partidoSeleccionado,
      getMultaEquipo,
      listMultas,
      changeTab,
      listDetalle,
      bloquearElRecibo,
      reciboGenerado,
      showLoadingIns,
      getInstituciones,
      listInstituciones,
      hasRecibo,
      reciboEliminado,
      limpiarDerecha,
      limpiandoDerecha,
      isReciboPagada,
      showLoadingPartidos,
      getMultaEquipoFirst,
      pagadoCorrectamente,
      showModalSemanas,
      listSemanas,
      listCampeonatos,
      campeonatoSeleccionado,
      setearVar,
      showLoadingRecibo,
      recargarMultasAlEliminar,
      listValoreFijos,
      dataReciboCabecera,
      recargarMultasAlInsertar,
      printRecibos,
      totalPartidos,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.etiquetas {
  display: flex;
  justify-content: center;
  font-size: 12px;
}
</style>
